import DonationAnime from './donation.gif'
import style from './style.module.scss'

const DonationMainHeader = ({ donation }) => {
    return (
        <a href={donation.link} className={style.donation}>
            <div className={style.media}>
                <img src={DonationAnime} alt={donation.label} />
            </div>
            <div className={style.label}>{donation.label}</div>
            <div className={style.bottom}>
                <div className={style.main} style={{ backgroundColor: style.darkBlue }} />
                <div style={{ backgroundColor: style.green }} />
                <div style={{ backgroundColor: style.purple }} />
                <div style={{ backgroundColor: style.red }} />
                <div style={{ backgroundColor: style.orange }} />
            </div>
        </a>
    )
}

export default DonationMainHeader
